<template>
  <div>
 

 <div style="min-height:120px;"></div>
  <div class="container-fluid mt--6">
	  <card header-classes="bg-gradient-default">
            <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3 text-white">
                	<span >Client Information</span>
        
                </h3>
              </div>
            </div>

            <div>
                <span class="h6 surtitle">Client Name</span>
                <div class="h3 ">{{client.client_name}}</div>
             </div>
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Client Email</span>
                <div class="h3 ">
                	<span> {{client.client_email}}</span>
                
                </div>
             </div>
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Client Address</span>
                <div class="h3 ">
                	<span> {{client.client_address}}</span>
                
                </div>
             </div>
          	
          	
          	 <div style="margin-top:30px;">
                <span class="h6 surtitle">Contact Number</span>
                <div class="h3 ">
                	<span> {{client.contact_number}}</span>
                
                </div>
             </div>
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Remarks</span>
                <div class="h3 ">
                	<span v-if="client.remarks"> {{client.remarks}}</span>
                	<span v-else>-</span>
                </div>
             </div>
             
        
          
          
          </card>
     
</div>
<!-- end  list -->    

        <div style="min-height:120px;"></div>

 <div class="container-fluid mt--6">
	
	
	
      <!--start new row-->
      
      <div class="row">
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 v-if="is_create == 1" slot="header" class="mb-0">Address Address</h3>
              <h3 v-else slot="header" class="mb-0">Update Address</h3>
              
              
              <!-- Card body -->
              <form class="needs-validation"   @submit.prevent="submit_form">
                <!-- Input groups with icon -->
        		
        		
        		
                 
                 
                 
                 <div class="row">
                  <div class="col-md-12">
                  
                  <base-input label="Client Address"
                      name="Client address"
                      placeholder=""
                      required
                      v-model="model.client_address">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                  <div class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Postal Code"
                      name="Postal code"
                      placeholder=""
                      required
                      v-model="model.postal_code">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
               
                
                
                
                <!--
                <base-input label="Remarks">
                    <textarea class="form-control" v-model="model.remarks"  rows="3"></textarea>
                 </base-input>
                  -->
                  
                
                <div>
                	<base-button v-if="is_create == 1" type="info" block native-type="submit">Add New Address</base-button>
                	<base-button v-else type="info" block native-type="submit">Update Address</base-button>
                </div>
              
              </form>
            </card>
            </div>
            </div>
            </div>
            
      
      
      
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
  import { Select, Option, Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  

  export default {
    components: {
  	  [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      TabPane,
      Tabs,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
     	 client:[],
     	 code: "",
     	 is_create: 1,
     	 model:{
     	 	client_name:'',
     	 	client_address:'',
     	 	contact_number:'',
     	 	client_email: '',
     	 	contact_person: '',
     	 	remarks:'',
     	 	client_type:1,
     	 },
     	 et_type_options:[],
     	 et_subtype_options:[],
     	 et_subtype_all_options:[],
     	 client_type_options: [
          {
            label: 'Company',
            value: 1
          },
          {
            label: 'Individual',
            value: 2
          },
        ],
	
      };
    },
    methods: {
  		submit_form(){
  				swal.showLoading();
  				var vm = this;
  				
  				vm.model.is_create  = this.is_create;
  				vm.model.client_id = this.client.id;
  				
  				let uri = vm.$base_url+'/api/clients/post/update_address';
				ApiService.post(uri, vm.model).then(response => {
					var msg = "New Address Created.";
					
					if(vm.model.is_create ==  0){
						msg = "Address Updated."
					}
					
				
			 		if(response.data.success == "y"){
			 				swal.fire({
									title: `Success`,
									text: msg,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'success'
							});
			 		}
			 		else{
			 			swal.fire({
									title: 'Error',
									text: response.data.error,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'warning'
							});
			 			
			 		}
			 })//end api service
  		},
  		viewClient(index, row) {
  			this.$router.push( '/manage-client/'+row.id)
  		
  		},
  		viewReports(index, row) {
  			this.$router.push( '/view-reports/'+row.id)
  		},
  		addReport(index, row) {
  			this.$router.push( '/add-report/'+row.id)
  		
  		},
  		et_change(){
  			
  			this.et_subtype_options = this.et_subtype_all_options[this.model.equipment_type][0];
  			this.model.equipment_subtype = this.et_subtype_options[0]['value'];
			
  		},
  		page_load(){
  			swal.showLoading();
				let uri = this.$base_url+'/api/clients/get/client/'+this.$route.params.cid;
				 ApiService.get(uri).then(response => {
			 
					 const vm = this;

					 this.client = response.data.client;
					 swal.close();
   
				})
				
				
  			if(this.$route.params.aid == 0){
  				this.is_create = 1;
  			
  			}
  			else{
  				this.is_create = 0;
				
  		
  		
  			}
  		},
  		to_confirm(){
  			
  		
  			var vm = this;
  			swal.fire({
					title: 'Are you sure?',
					text: 'You are changing the password for the virtual tour to:     '+ this.model.code,
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes, proceed.',
					buttonsStyling: false
				  }).then((result)=> {	
				  
				  		 if (result.isConfirmed) {
				  		 	 var $base_url = "https://kh.rollingatlas.com/kh/public";
				  			 let uri = vm.$base_url+'/api/change_code';
							 ApiService.post(uri, vm.model).then(response => {
			 						if(response.data.success == "y"){
			 							vm.code = response.data.code;
			 							swal.fire({
												title: `Success`,
												text: 'Virtual Tour Password Updated.',
												buttonsStyling: false,
												confirmButtonClass: 'btn btn-success',
												icon: 'success'
										 });
			 						}
			 				})
				  		 
				  		 }
				  		 else{
				  		 
				  		 
				  		 }
				  			
			 
					}
					
					)//end swal

  		}
    },
    mounted() {
      	
      	this.page_load();
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














